import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import DialogEdit from "./DialogEdit";
import {
  IconButton,
  Button
} from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
 
}));



export default function ButtonEdit({ product, project_id, reloadData }) {
  const classes = useStyles();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOnOpen = () => {
    setIsDialogOpen(true);
  };
  const handleOnClose = () => {
    setIsDialogOpen(false);
  }; 
 
  return (
    <>     
      
        {product?(
          <IconButton size='small' onClick={handleOnOpen}
          alt="Edit this product"
          title="Edit this product"
          >
            <EditIcon/>
          </IconButton>      
        ):(
          <Button  variant="contained" startIcon={<AddIcon />} onClick={handleOnOpen}>
            New Product
          </Button>
        )}
      
      <DialogEdit
        //fullScreen
        open={isDialogOpen}
        onClose={handleOnClose}
        product={product}
        project_id={project_id}
        reloadData={reloadData}
      />
    </>
  );
}
